// extracted by mini-css-extract-plugin
export default {"menu":"Menu-menu-Uz3_0"};